import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { Button, Divider, Label, SreenCoverLoading } from "src/components";
// import { ApplyPaperPopupContents } from "src/components/PopupPageContents";
import { useAlert, useConfirm } from "src/hooks";
import { createTeeshotAxiosInstance } from "src/http";
import { recoilStates } from "src/recoil/recoilStates";
import STATIC_DATA from "src/staticData";
import { colors } from "src/styles/theme";
import { parseJsonStr } from "src/utils";
import styled from "styled-components";

type Sc = {
  months: { name: string }[];
  weeks: { name: string }[];
  days: { name: string }[];
  time: { name: string };
};
type RegisterDataType = {
  submitUser: {
    id: number;
    name: string;
    phone_number: string;
  };
  groupName: string;
  location: string;
  clubs: { preference: number; name: string }[];
  teamCount: { count: number };
  schedule: {
    first: Sc;
    second?: Sc;
  };
  playReq?: {
    caddyOpt?: { name: string };
    caddyCount?: number;
    cart5?: { count: number };
    cart2?: { count: number };
  };
  playType?: {
    name: string;
  };
  teeType?: {
    name: string;
  };
  etcReq?: { name: string }[];
  payment?: {
    green?: { id: number };
    cart?: { id: number };
    caddy?: { id: number };
    snackBar: { id: number };
    meal: { id: number };
  };
  addReq?: string;
};

export default function YearBookingRegisterResult() {
  const navigate = useNavigate();
  const [group] = useRecoilState(recoilStates.group);
  const [bookingApplication] = useRecoilState(recoilStates.bookingApplication);
  const [isCoverLoading, setIsCoverLoading] = useState(false);
  const alert = useAlert();

  // 디버깅용 콘솔 출력
  console.log("bookingApplication:", bookingApplication);
  console.log("hopeDates:", bookingApplication?.hopeDates);
  //TODO 새로고침 오류 수정
  useEffect(() => {
    if (!bookingApplication?.id) {
      (async () => {
        alert({ content: "부킹신청 내역이 없습니다.", onClose: () => alert.resume() });
        await alert.pause();

        navigate("/");
      })();
    }
  }, []);

  const confirm = useConfirm();
  // const { PopupComponent: ApplyPopupComp, openPopup: openApplyPopupComp } = usePopupPage("apply");

  return (
    <Container className="flex-1 d-flex fd-c gap-3 ">
      <h3 className="fs-5 fw-b">{group?.name}</h3>
      <div className="d-flex fd-c gap-2">
        <Label className="bold" content={"라운드 일자"} />
        <RoundCard>
          {/* {bookingApplication?.clubRels.map((c) => { */}
          {/* <div className="d-flex fd-c gap-1">
            <div className="d-flex gap-3" key={c.name}>
              <Input
                attr={{
                  readOnly: true,
                  value: c.preference,
                  style: { width: 30, textAlign: "center" },
                }}
              />
              <Input
                boxClassName="flex-1"
                attr={{ readOnly: true, value: c.name, style: { flex: 1 } }}
              /> */}
          {/* <Button
                        // className="as-c"
                        $round
                        $colorTheme="black"
                        // $buttonSize="md"
                        onClick={() => {
                          openApplyPopupComp();
                        }}
                      >
                        신청서 보기
                      </Button> */}
          {/* </div>
          </div> */}
          {/* })} */}
          <CardLayout>
            <CardText>희망 월</CardText>
            <MonthButtonContainer>
              {(() => {
                const months = bookingApplication?.hopeDates?.[0]?.month_arr_json_str;
                if (!months) return <div> - </div>;
                return JSON.parse(months).map((m: number) => (
                  <MonthButton key={m} className="ml-2 fw-n">
                    {m}월
                  </MonthButton>
                ));
              })()}
            </MonthButtonContainer>
          </CardLayout>
          <div>
            {bookingApplication?.hopeDates?.map((hd) => {
              // hd.preference;

              return (
                <CardLayout key={`hd-${hd.id}`} className="cols-container-55">
                  <CardText>{hd.preference}지망</CardText>
                  <TextWeight700>
                    {JSON.parse(hd?.week_arr_json_str ?? [])
                      .map((w: number) => `${w}주`)
                      .join(", ")}{" "}
                    {JSON.parse(hd?.day_arr_json_str ?? [])
                      .map((d: string) => `${d}요일`)
                      .join(", ")}{" "}
                    {hd?.start_time?.slice(0, 2)}:{hd?.start_time?.slice(2, 4)}
                  </TextWeight700>
                </CardLayout>
              );
            })}
          </div>
        </RoundCard>
      </div>
      <Label className="bold" content={"예약 정보"} />
      <RegisterCard>
        <CardLayout>
          <CardText>신청자</CardText>
          <TextWeight700>
            {group?.members?.find((m) => m?.id === bookingApplication?.applying_member_id)?.name ||
              " - "}
          </TextWeight700>
        </CardLayout>
        <CardLayout>
          <CardText>연락처</CardText>
          <TextWeight700>
            {group?.members?.find((m) => m?.id === bookingApplication?.applying_member_id)
              ?.phone_number || " - "}
          </TextWeight700>
        </CardLayout>
        <CardLayout>
          <CardText>신청 팀수</CardText>
          <TextWeight700>{bookingApplication?.team_amount} 팀</TextWeight700>
        </CardLayout>
        <CardLayout>
          <CardText>행사 성격</CardText>
          <TextWeight700>연간 부킹</TextWeight700>
        </CardLayout>
        <CardLayout>
          <CardText>행사명</CardText>
          <TextWeight700>{group?.name || " - "}</TextWeight700>
        </CardLayout>
      </RegisterCard>
      {/* <div className="ml-2">{bookingApplication?.team_amount} 팀</div> */}
      <Divider />
      <Label className="bold" content={"희망 골프장"} />
      {bookingApplication?.clubRels?.map((club, index) => (
        <GolfClubCard key={club.id || index}>
          <TextWeight600>
            {" "}
            {club.preference}. {club.name}
          </TextWeight600>
        </GolfClubCard>
      ))}
      <Divider />
      <div className="d-flex fd-c gap-1">
        <Label className="bold" content={"시설이용"} />
        <RegisterCard>
          {[
            {
              label: "결제방식",
              value:
                STATIC_DATA.PAY_TYPE_DATA.find((d) => d.id === bookingApplication?.payment_type_id)
                  ?.name || " - ",
            },
            {
              label: "식사 선택",
              value:
                STATIC_DATA.MEAL_TYPE_DATA.find((d) => d.id === bookingApplication?.meal_type_id)
                  ?.name || " - ",
            },
            {
              label: "프로샵 이용",
              value: bookingApplication?.proshop_item || " - ",
            },
            {
              label: "룸 이용",
              value:
                STATIC_DATA.ROOM_TYPE_DATA.find((d) => d.id === bookingApplication?.room_type_id)
                  ?.name || " - ",
            },
          ].map((item, index) => (
            <CardLayout key={index}>
              <CardText>{item.label}</CardText>
              <TextWeight700>{item.value}</TextWeight700>
            </CardLayout>
          ))}
        </RegisterCard>
        {/* <RegisterCard
          content={
            <div className="d-flex fd-c gap-2">
              <div className="cols-container-55">
                <div>결제</div>
                <div className="fw-n">
                  {STATIC_DATA.PAY_TYPE_DATA.find(
                    (d) => d.id === bookingApplication?.payment_type_id
                  )?.name || "  "}
                </div>
              </div>
              <div className="cols-container-55">
                <div>식사</div>
                <div className="fw-n">
                  {STATIC_DATA.MEAL_TYPE_DATA.find((d) => d.id === bookingApplication?.meal_type_id)
                    ?.name || " - "}
                </div>
              </div>
              <div className="cols-container-55">
                <div>프로샵</div>
                <div className="fw-n">{bookingApplication?.proshop_item || " - "}</div>
              </div>
            </div>
          }
        /> */}
      </div>
      <Label className="bold" content={"경기 및 시상"} />
      <RegisterCard>
        {[
          {
            label: "경기방식",
            value:
              STATIC_DATA.GAME_TYPE_DATA.find((d) => d.id === bookingApplication?.game_type_id)
                ?.name || " - ",
          },
          {
            label: "티사용",
            value:
              STATIC_DATA.TEEBOX_TYPE_DATA.find((d) => d.id === bookingApplication?.teebox_type_id)
                ?.name || " - ",
          },
          {
            label: "시상내용",
            value: (() => {
              const awards = parseJsonStr(bookingApplication?.award_ids_arr_json_str || "");
              if (!awards || !awards.length) {
                return " - ";
              }
              return STATIC_DATA.AWARDS_DATA.filter((d) => awards.includes(d.id))
                .map((x) => x.name)
                .join(", ");
            })(),
          },
          {
            label: "요청사항",
            value: bookingApplication?.etcRequirements?.map((e) => e.name)?.join(", ") || " - ",
          },
        ].map((item, index) => (
          <CardLayout key={index}>
            <CardText isAward={item.label === "시상내용"}>{item.label}</CardText>
            <TextWeight700>{item.value}</TextWeight700>
          </CardLayout>
        ))}
      </RegisterCard>
      <Label className="bold" content={"객단가"} />
      <RegisterCard>
        <CardLayout>
          <CardText>객단가</CardText>
          <TextWeight700>
            {(() => {
              const priceId = bookingApplication?.price_per_person_id;
              if (!priceId) {
                return " - ";
              }
              if (Number(priceId) && Number(priceId) < 5) {
                return `${priceId} 만원`;
              }
              return `${priceId} 만원 이상`;
            })()}
          </TextWeight700>
        </CardLayout>
      </RegisterCard>
      {/* <ApplyPopupComp type="x" headerMsg="신청서" content={<ApplyPaperPopupContents />} /> */}
      <Button
        $round
        className="mt-6"
        $colorTheme="white"
        $outline={true}
        $buttonSize="md"
        onClick={() => {
          confirm({
            title: "부킹취소",
            content: "정말로 부킹신청을 취소하시겠습니까?",
            onConfirm: () => {
              (async () => {
                try {
                  setIsCoverLoading(true);
                  await createTeeshotAxiosInstance().post("/yearBooking/booking/user-cancel", {
                    bookingId: bookingApplication?.id,
                  });
                } catch (e) {
                  console.log("e :", e);
                  setIsCoverLoading(false);
                  alert({
                    content: "취소요청 실패",
                    onClose: () => {
                      alert.resume();
                    },
                  });
                  await alert.pause();
                } finally {
                  setIsCoverLoading(false);
                  navigate("/");
                  window.location.reload();
                }
              })();
            },
          });
        }}
      >
        신청 취소하기
      </Button>
      {isCoverLoading && <SreenCoverLoading />}
    </Container>
  );
}

const Container = styled.div`
  padding: 16px;
  * {
    word-wrap: break-word;
    white-space: break-spaces;
    word-break: break-all;
  }
  label {
  }
  /* .dates-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
  } */

  .applier {
    background-color: ${colors.gray.third};
    padding: 5px;
  }
  .cols-container-55 {
    display: flex;
    gap: 5px;
    > :first-child {
      flex-basis: 55px;
    }
  }
  .cols-container-70 {
    display: flex;
    gap: 5px;
    > :first-child {
      flex-basis: 70px;
      flex-shrink: 0;
    }
  }
`;

const Card = styled.div`
  text-align: start;
  display: flex;
  flex-direction: column;
  padding: 19px 16px;
  background-color: #f0f0f4;
  border-radius: 6px;
  width: 100%;
  flex-shrink: 0;
`;

const RoundCard = styled(Card)`
  gap: 40px;
`;
const RegisterCard = styled(Card)`
  gap: 10px;
`;

const GolfClubCard = styled(Card)`
  gap: 10px;
`;

const CardText = styled.div<{ isAward?: boolean }>`
  min-width: ${(props) => (props.isAward ? "80px" : "50px")};
`;

const TextWeight700 = styled.div`
  font-weight: 700;
`;

const TextWeight600 = styled.div`
  font-weight: 600;
`;

const CardLayout = styled.div`
  padding: 4px;
  display: flex;
  justify-content: space-between;
`;
const MonthButtonContainer = styled.div`
  display: flex;
  gap: 5px 0px;
  flex-wrap: wrap;
`;
const MonthButton = styled.div`
  display: flex;
  padding: 4px 6px;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  color: #fff;
  background-color: #000000;
  border-radius: 6px;
`;
